module.exports = __webpack_public_path__ + "static/media/Avatars_Male_New-01.bd035514.png";